"use client"

import { useState } from "react"
import "./NearFaq.css"

const faqData = [
  {
    question: "How does the managed teams process work?",
    answer:
      "We offer two main solutions: Managed Teams and Managed Project. Managed Teams provide a web design and development squad or individual professionals tailored to your needs, integrated seamlessly into your delivery team and processes. Managed Project involves developing the project in-house, ensuring world-class quality and efficiency, ideal for companies without internal technical teams.",
  },
  {
    question: "What benefits do i gain from nearshore teams?",
    answer:
      "You'll experience rapid team setup within two weeks, accelerating development processes by up to 70%. Our EU-based teams offer seamless collaboration and cultural fit. You can scale your team up or down as needed, accessing a pool of digital product experts without HR bureaucracy or extra costs.",
  },
  {
    question: "What steps are involved in the Managed Teams process?",
    answer:
      "The process encompasses Profiling, Enablement, Development, and Phasedown stages. Profiling involves understanding project goals and position requirements, enabling us to select the best-suited candidates. Enablement focuses on administrative setup, onboarding, and project reviews. Development emphasizes career growth, training, and account reviews. Phasedown ensures seamless closure and debriefing.",
  },
  {
    question: "When should i consider using nearshore teams?",
    answer:
      "Nearshore Teams are beneficial in several scenarios:• Reinforcing your in-house team:If you have a large project that your current staff can't handle alone, nearshore teams can provide the additional skill sets and manpower needed.• Bridging skill gaps:It's ideal for filling talent deficits in specific areas or roles where your team lacks expertise.• Quick team expansion:When you need to rapidly grow your team to meet increasing demands, a nearshore team provides an immediate solution without the delay of hiring and training new employees.• Meeting deadlines:Extra skilled personnel can help ensure timely completion of projects, especially when facing strict deadlines.• When other models fail:If traditional hiring or other business models aren't delivering the desired results, nearshore teams offer a flexible and effective alternative.",
  },
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section6166">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">NEARSHORE TEAMS SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
